var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRadioOff = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16m0-1a7 7 0 1 0 0-14 7 7 0 0 0 0 14"
})));
export { SvgRadioOff as ReactComponent };
export default __webpack_public_path__ + "static/media/radioOff.77ce191b.svg";